import { Vector } from './Vector'

export class matrix {
    readonly rows: number;
    readonly columns: number;
    private values: number[] = [];

    constructor(rows: number, columns: number) {
        this.rows = rows;
        this.columns = columns;
        this.values = [];
        this.values.length = rows * columns;
    }

    setValues(values: number[]): void {
        if (values.length !== this.rows * this.columns) {
            throw new Error('Matrix value count does not match matrix dimensions');
        }

        this.values = [...values];
    }

    getItem(row: number, column: number): number {
        return this.values[row * this.columns + column];
    }

    multiply(vector: Vector) {
        let x = this.getItem(0, 0) * vector.x
            + this.getItem(0, 1) * vector.y
            + this.getItem(0, 2) * vector.z;

        let y = this.getItem(1, 0) * vector.x
            + this.getItem(1, 1) * vector.y
            + this.getItem(1, 2) * vector.z;

        let z = this.getItem(2, 0) * vector.x
            + this.getItem(2, 1) * vector.y
            + this.getItem(2, 2) * vector.z;
        return new Vector(x, y, z);
    }

    /*
    0  1  2
    0  [0, 1, 2
    1   3, 4, 5
    2   6, 7, 8]
    */
    //return self;
}
